import React from 'react';

import { Polyglot } from 'components/translate';
import Number from 'helpers/Number';
import {
  ENGAGEMENT_LABELS,
  SMALLEST_VISIBLE_PERCENT
} from 'modules/userManager/constants';
import UserManagerStore from 'modules/userManager/UserManagerStore';

import BigNumbersEngagmentBars from './BigNumbersEngagementBars';

class BigNumbersFormat {
  formatBigNumber(bigNumber) {
    const translatedData = this.translateData(bigNumber);
    const { type } = bigNumber;

    return this[type]
      ? this[type](bigNumber, translatedData)
      : this.percent(bigNumber, translatedData);
  }

  formatPercentage(number) {
    if (!number) {
      return 0;
    }

    if (number < SMALLEST_VISIBLE_PERCENT) {
      return `< ${SMALLEST_VISIBLE_PERCENT}`;
    }

    const decimalPlaces = number < 1 ? 1 : 0;

    return number.toFixed(decimalPlaces);
  }

  translateData(bigNumber) {
    return {
      ...bigNumber,
      title: Polyglot.t(bigNumber.title),
      description: Polyglot.t(bigNumber.description, { checkOnlineEvent: true })
    };
  }

  percent(bigNumber, translatedData) {
    return {
      ...translatedData,
      value: `${this.formatPercentage(bigNumber.value)}%`
    };
  }

  areaTotalUsers(bigNumber, translatedData) {
    const searchPercentage = this.formatPercentage(bigNumber.searchPercentage);

    return {
      ...translatedData,
      value: Number.format(UserManagerStore.totalElements),
      description: `${searchPercentage}${Polyglot.t(bigNumber.description, {
        checkOnlineEvent: true
      })}`
    };
  }

  avgEngagement(bigNumber, translatedData) {
    const label = ENGAGEMENT_LABELS[bigNumber.value] || ENGAGEMENT_LABELS[0];

    return {
      ...translatedData,
      value: Polyglot.t(label),
      renderRightColumn: () => (
        <BigNumbersEngagmentBars activeItem={bigNumber.value} />
      )
    };
  }
}

export default new BigNumbersFormat();
